var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 8.25H14.6667V6.41665C14.6667 2.87848 11.7882 0 8.25 0C4.71178 0 1.83335 2.87848 1.83335 6.41665V8.25H0.458348C0.205004 8.25 0 8.455 0 8.70835V20.1667C0 21.1778 0.822207 22 1.83335 22H14.6667C15.6778 22 16.5 21.1778 16.5 20.1667V8.70835C16.5 8.455 16.295 8.25 16.0417 8.25ZM9.62234 17.8244C9.63664 17.9538 9.59505 18.0836 9.50821 18.1807C9.42137 18.2778 9.29693 18.3333 9.1667 18.3333H7.33335C7.20311 18.3333 7.07867 18.2778 6.99183 18.1807C6.90499 18.0836 6.86336 17.9538 6.87771 17.8244L7.16684 15.2244C6.69732 14.8829 6.4167 14.3426 6.4167 13.75C6.4167 12.7389 7.2389 11.9167 8.25004 11.9167C9.26118 11.9167 10.0834 12.7389 10.0834 13.75C10.0834 14.3426 9.80276 14.8829 9.33324 15.2244L9.62234 17.8244ZM11.9167 8.25H4.58335V6.41665C4.58335 4.39489 6.22823 2.75 8.25 2.75C10.2718 2.75 11.9167 4.39489 11.9167 6.41665V8.25Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.de3285eb2c3f0cec9b0b847978f71b00.svg";
export { ForwardRef as ReactComponent };